import { getStore } from "../api/storePresentation";
import { getSocialLinks } from "../../i18n/utilities";

import {
  DEFAULT,
  FEMALE,
  MALE,
  SECURE
} from "../template/state/modules/layout/constants";

const TYPES = [DEFAULT, FEMALE, MALE, SECURE];

export { DEFAULT, FEMALE, MALE, SECURE };

const addTrailingSlash = str => `${str}/`;

export const storeUrlsForAllFloors = async (
  countryCode,
  platform,
  keyStoreDataversion,
  shouldUseHttps = false
) => {
  const storeUrls = {};
  for (const i in TYPES) {
    const type = TYPES[i];
    storeUrls[type] = addTrailingSlash(
      await getStore().getStoreUrlByCountryCode({
        countryCode,
        type,
        keyStoreDataversion,
        includeProtocol: true,
        shouldUseHttps,
        isMobile: platform === "mobile"
      })
    );
  }
  return storeUrls;
};

export const storeLinksForAllFloors = storeCode =>
  TYPES.reduce(
    (links, type) => ({
      ...links,
      [type]: getSocialLinks({ storeCode, floor: type })
    }),
    {}
  );



// WEBPACK FOOTER //
// ./helpers/storeUrls.js